import React from 'react';
import PropTypes from 'prop-types';

var FormLabel = function FormLabel(_a) {
  var children = _a.children,
      htmlFor = _a.htmlFor,
      form = _a.form;
  var labelClassNames = "text-xs text-body leading-125 tw:text-sm tw:text-tw-secondary-800 tw:leading-150 tw:font-normal";
  return /*#__PURE__*/React.createElement("label", {
    className: labelClassNames,
    htmlFor: htmlFor,
    form: form
  }, children);
};
FormLabel.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  form: PropTypes.string
};

export { FormLabel };
//# sourceMappingURL=index.es.js.map
